// API Configuration
export const API_CONFIG = {
	// Base URL for the backend API
	BASE_URL: process.env.NEXT_PUBLIC_BACKEND_HOST || "http://localhost:3000",

	// API endpoints
	ENDPOINTS: {
		// Authentication
		LOGIN: "/users/login",
		REGISTER: "/users/register",
		PROFILE: "/users/profile",
		VERIFY_EMAIL: "/users/verify-email",
		REQUEST_PASSWORD_RESET: "/users/request-password-reset",
		RESET_PASSWORD: "/users/reset-password",
		CHANGE_PASSWORD: "/users/change-password",

		// XBRL parsing
		XBRL_PARSE: "/xbrl-parsing/parse",
		XBRL_FILES: "/xbrl-parsing/files",

		// Conto economico
		CONTO_ECONOMICO_MY: "/conto-economico/user",
		CONTO_ECONOMICO_ADMIN: "/conto-economico/admin",
	},

	// Cookie configuration
	COOKIE_CONFIG: {
		ACCESS_TOKEN: "access_token",
		EXPIRES_DAYS: 7,
		SECURE: process.env.NODE_ENV === "production",
		SAME_SITE: "strict" as const,
	},

	// Request configuration
	REQUEST_CONFIG: {
		TIMEOUT: 30000, // 30 seconds
		RETRY_ATTEMPTS: 3,
	},
};

// Helper function to get cookie configuration
export const getCookieConfig = () => {
	return {
		expires: API_CONFIG.COOKIE_CONFIG.EXPIRES_DAYS,
		secure: API_CONFIG.COOKIE_CONFIG.SECURE,
		sameSite: API_CONFIG.COOKIE_CONFIG.SAME_SITE,
	};
};
